import { createTheme } from '@mui/material/styles';

export const colors = {
  bg: '#FFFFFF',
  cardAlt: '#F8FAFC',
  primary: '#2563EB',
  primaryDark: '#1D4ED8',
  primarySoft: '#EFF6FF',
  accent: '#0EA5E9',
  text: '#0F172A',
  muted: '#475569',
  subtle: '#64748B',
  border: 'rgba(15, 23, 42, 0.08)',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: colors.primary, dark: colors.primaryDark },
    background: { default: colors.bg, paper: '#FFFFFF' },
    text: { primary: colors.text, secondary: colors.muted },
    divider: colors.border,
  },
  typography: {
    fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
    h1: {
      fontFamily: `'Manrope', 'Inter', sans-serif`,
      fontWeight: 800,
      letterSpacing: '-0.03em',
    },
    h2: {
      fontFamily: `'Manrope', 'Inter', sans-serif`,
      fontWeight: 800,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontFamily: `'Manrope', 'Inter', sans-serif`,
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    h4: {
      fontFamily: `'Manrope', 'Inter', sans-serif`,
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    h5: { fontFamily: `'Manrope', 'Inter', sans-serif`, fontWeight: 700 },
    h6: { fontFamily: `'Manrope', 'Inter', sans-serif`, fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
        containedPrimary: {
          background: `linear-gradient(180deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
        },
      },
    },
    MuiPaper: { styleOverrides: { root: { borderRadius: 16 } } },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
          backgroundColor: colors.primarySoft,
          color: colors.primaryDark,
        },
      },
    },
  },
});

export default theme;
